import * as React from 'react';
import { api } from 'services/api';
import type {  CreateRedirectedProductsPayload  } from 'contracts/redirected-products';

export const useCreateRedirectedProducts = () => {
  const createRedirectedProducts = React.useCallback(async (payload: CreateRedirectedProductsPayload) => {
    await api.post('/inventory/redirected-products/create-many', payload);
  }, []);

  return {
    createRedirectedProducts,
  }
};